import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Portal } from 'react-portal';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import * as Types from 'types';
import { request } from 'utils/request';
import { configureStore } from 'store/configureStore';
import { ArtStreamLanding } from 'apps/art-stream/ArtStreamLanding';
import { ArtStreamWelcome } from 'apps/art-stream/ArtStreamWelcome';
import { Pending } from 'apps/art-stream/Pending';
import { AnimatedCarousel } from 'components/carousel/AnimatedCarousel';
import { monitorVisibilityForQuery } from 'services/monitorVisibility';
import { UpdateCreditCardButton } from 'apps/art-stream/UpdateCreditCardButton';
import {
  handleMonthlyCheckoutClick,
  handleYearlyCheckoutClick,
} from 'apps/art-stream/services/checkout';
import { mapLegacyArtworkToArtwork } from 'features/artworks/api';

const url = '/api/internal/artworks';
const params = new URLSearchParams([
  ['serializer', 'legacy'],
  ['filter', 'slate_name'],
  ['slate_name', 'carousel-artworks'],
]);

const store = configureStore();
const container = document.getElementById('app');

const ArtStream: React.FC<{}> = () => {
  const [artworks, setArtworks] = useState([] as Types.Artwork[]);

  useEffect(() => {
    request.get(`${url}?${params.toString()}`).then(({ data }) => {
      const artworksArray: Types.Artwork[] = data.map(mapLegacyArtworkToArtwork);
      setArtworks(artworksArray);
    });
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path={Routes.art_stream_path()}>
            <div>
              <Portal node={document.getElementsByClassName('js-artworks-carousel')[0]}>
                <AnimatedCarousel initialArtworks={artworks} staggered />
              </Portal>
              <ArtStreamLanding />
            </div>
          </Route>
          <Route exact path={Routes.meta_art_stream_path()}>
            <div>
              <Portal node={document.getElementsByClassName('js-artworks-carousel')[0]}>
                <AnimatedCarousel initialArtworks={artworks} staggered />
              </Portal>
              <ArtStreamLanding />
            </div>
          </Route>
          <Route exact path={Routes.corporate_art_stream_path()}>
            <div>
              <ArtStreamLanding />
            </div>
          </Route>
          <Route exact path={Routes.welcome_art_stream_path()}>
            <ArtStreamWelcome />
          </Route>
          <Route exact path={Routes.pending_art_stream_path()}>
            <Pending />
          </Route>
        </Switch>
      </Router>
    </Provider>
  );
};

if (container) {
  ReactDOM.render(<ArtStream />, container);
}

monitorVisibilityForQuery('.js-monitor-visibility');

$('.js-buy-art-stream-monthly').each((_, el) => {
  $(el).on('click', handleMonthlyCheckoutClick);
});

$('.js-buy-art-stream-yearly').each((_, el) => {
  $(el).on('click', handleYearlyCheckoutClick);
});

const $updateStripeCardDetailsEl = $('.js-update-stripe-card-details');
if ($updateStripeCardDetailsEl.length > 0) {
  ReactDOM.render(<UpdateCreditCardButton />, $updateStripeCardDetailsEl[0]);
}
